module.exports = __webpack_public_path__ + "img/recom_01.jpg";